import { useEffect, useMemo, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { useToast } from "../../../Hooks/UseToast";
import PantallaNoHayViandas from "./PantallaNoHayViandas";
import { Button, Container, Typography } from "@mui/material";
import MostrarMenuSemanal from "./MostrarMenuSemanal";
import { GenerarSemana } from "./FechasSemana";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Navbar";
import SaveIcon from "@mui/icons-material/Save";
import moment from "moment";

const USERNAMES_NETIZAR = [
  "nicolaspascucci",
  "ignaciobastianelli",
  "micaelairibarren",
  "mperea",
  "eduardo",
];

const ALLOWED_SUCURSALES = [8, 1000];

const SeleccionarViandasV2 = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tableMenuState, setTableMenuState] = useState(false);
  const [rotativeMenus, setRotativeMenus] = useState([]);
  const [ejecutiveMenus, setEjecutiveMenus] = useState([]);
  const [userSelection, setUserSelection] = useState({});
  const [copyUserSelection, setCopyUserSelection] = useState(userSelection);
  const [cantidadDeDiasDelaSemana, setCantidadDeDiasDeLaSemana] = useState(0);

  const usuario = useMemo(() => localStorage.getItem("user"), []);
  const sucursal = useMemo(() => localStorage.getItem("sucursal"), []); //idSucursal

  const navigate = useNavigate();

  const { showToast, Toast } = useToast();

  const checkFreeDaysOfWeek = async () => {
    const response = await fetch(`${UrlApi}/viandas/menu/daysFeriado`);
    if (!response.ok) return;
    const data = await response.json();

    const dataParsed = data.map((item) => {
      const [dia, fecha] = Object.entries(item)[0];
      return {
        dia,
        fecha:
          fecha !== "feriado"
            ? moment(fecha, "DD/MM/YYYY").format("YYYY-MM-DD")
            : "feriado",
      };
    });
    const initialSelection = {};
    dataParsed.forEach(({ fecha }) => {
      if (fecha !== "feriado") initialSelection[fecha] = undefined;
    });
    setCantidadDeDiasDeLaSemana(Object.keys(initialSelection).length);
    setUserSelection(initialSelection);
  };

  const checkTableStatus = async () => {
    try {
      const response = await fetch(`${UrlApi}/viandas/tabla/estado`);
      const data = await response.json();
      setTableMenuState(data.bloqueado);
    } catch (err) {
      console.error("Error al consultar el estado de la tabla");
      showToast("Error al consultar el estado de la tabla", "error");
    }
  };

  const getEjecutiveMenus = async () => {
    try {
      let response = await fetch(`${UrlApi}/viandasfech/obtenermenudiario`);
      response = await response.json();
      setEjecutiveMenus(
        response?.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)),
      );
    } catch (err) {
      console.error("Error al traer los datos del menu ejecutivo");
      showToast("Error al consultar el menu ejecutivo", "error");
    }
  };
  const tienePedidosOriginales = Object.values(copyUserSelection).some(
    (item) => item?.id_menu > 0,
  );

  const tienePedidosActuales = Object.values(userSelection).some(
    (item) => item?.id_menu > 0,
  );

  const todosLosDiasRespondidos =
    Object.keys(userSelection).length === cantidadDeDiasDelaSemana &&
    Object.values(userSelection).every((item) => item?.id_menu !== undefined);

  const huboCambios =
    JSON.stringify(userSelection) !== JSON.stringify(copyUserSelection);

  const disabled = (() => {
    if (isSubmitting) return true;

    if (!todosLosDiasRespondidos) return true;

    // Nunca tuvo pedidos y sigue sin tenerlos
    if (!tienePedidosOriginales && !tienePedidosActuales) {
      return true;
    }

    // Ya tenia pedidos, o esta creando nuevos
    return !huboCambios;
  })();

  const getRotativeMenus = async () => {
    try {
      let response = await fetch(`${UrlApi}/viandasfech/obtenermenurotativo2`);
      response = await response.json();

      const regex = /^\d{1,2}-/;
      const rotativosFiltrados = response.filter((menu) =>
        regex.test(menu.menu),
      );
      setRotativeMenus(rotativosFiltrados);
    } catch (err) {
      console.error("Error al traer los datos del menu rotativo");
      showToast("Error al consultar el menu rotativo", "error");
    }
  };

  const getExistingOrders = async (initDate, endDate, username) => {
    const response = await fetch(
      `${UrlApi}/viandasfech/existepedidos/${initDate}_${endDate}?username=${username}`,
    );

    if (!response.ok) return;

    const data = await response.json();

    const filtredData = data.map(({ id_pedidos, id_menu, fecha }) => ({
      id_pedidos,
      id_menu,
      fecha: fecha.split("T")[0],
    }));

    const selectionObj = Object.fromEntries(
      semanaCompleta.map(({ fecha }) => {
        const match = filtredData.find((item) => item.fecha === fecha);
        return [
          fecha,
          {
            id_menu: match ? match.id_menu : undefined,
            id_pedidos: match ? match.id_pedidos : undefined,
          },
        ];
      }),
    );

    const hasAtLeastOneValue = Object.values(selectionObj).some(
      (item) => item.id_menu !== undefined,
    );

    if (hasAtLeastOneValue) {
      const seleccionFinal = Object.fromEntries(
        Object.entries(selectionObj).filter(
          ([_, value]) => value?.id_menu !== undefined,
        ),
      );

      setUserSelection(seleccionFinal);
      setCopyUserSelection(seleccionFinal);
    }
  };

  const semanaCompleta = GenerarSemana();

  useEffect(() => {
    checkTableStatus();
    getEjecutiveMenus();
    checkFreeDaysOfWeek();
    getRotativeMenus();
    const init = async () => {
      await getExistingOrders(
        semanaCompleta[0].fecha,
        semanaCompleta[4].fecha,
        usuario,
      );
    };
    init();
  }, []);

  const handleSelect = (fecha, tipo, valor) => {
    const fechaFormateada = fecha.split("T")[0];

    setUserSelection((prev) => ({
      ...prev,
      [fechaFormateada]: {
        ...prev[fechaFormateada],
        [tipo]: valor,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // let sucursalSegura = USERNAMES_NETIZAR.includes(usuario)
      //   ? 1000
      //   : ALLOWED_SUCURSALES.includes(Number(sucursal))
      //     ? sucursal
      //     : 8;

      const datos = {
        pedidosObj: userSelection,
        username: usuario,
        id_sucursal: 8,
      };
      const response = await fetch(`${UrlApi}/viandas/pedidos/sync`, {
        method: "PUT",
        body: JSON.stringify(datos),
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok)
        throw new Error(
          "Ocurrio un error al guardar las viandas. Intentelo nuevamente",
        );
      navigate("/viandas/confirmacion", {
        state: {
          username: usuario,
          pedidos: userSelection,
          menus: [...rotativeMenus, ...ejecutiveMenus],
        },
      });
    } catch (err) {
      console.error(err);
      showToast(`${err}`, "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  if (tableMenuState) return <PantallaNoHayViandas />;

  return (
    <>
      <Navbar />
      <Container
        sx={{
          width: "100%",
          px: "auto",
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Typography sx={{ mt: 4 }} variant="h3">
          <Typography
            component="span"
            variant="h3"
            sx={{ color: "#3e513b", mt: 4 }}
          >
            Hola
          </Typography>
          , seleccioná tus viandas de la semana
        </Typography>
        <MostrarMenuSemanal
          handleSelect={handleSelect}
          ejecutiveMenus={ejecutiveMenus}
          rotativeMenus={rotativeMenus}
          userSelection={userSelection}
        />
        <Button
          onClick={handleSubmit}
          disabled={disabled}
          sx={{
            backgroundColor: "#3e513b",
            py: 1.5,
            px: 4,
            borderRadius: 2,
            mb: 10,
            mt: 4,
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#2d3e2a",
            },
          }}
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
        >
          Confirmar pedido
        </Button>
      </Container>
      {Toast}
    </>
  );
};

export default SeleccionarViandasV2;
